import { Button, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';

import * as S from './style';

const RocketModal = ({
  title,
  desc,
  firstButtonText,
  firstButtonClick,
  secondButtonText,
  secondButtonClick
}) => (
  <S.OnboardingWrapper>
    <S.RocketBody>
      <Typography variant="subtitle2Bold">{title}</Typography>
      <Typography variant="subtitle4Light" style={{ marginTop: 16 }}>
        {desc}
      </Typography>

      <S.ButtonGroup>
        {firstButtonClick && <Button onClick={firstButtonClick}>{firstButtonText}</Button>}
        {secondButtonText && (
          <Button variant="outlined" onClick={secondButtonClick}>
            {secondButtonText}
          </Button>
        )}
      </S.ButtonGroup>
    </S.RocketBody>
  </S.OnboardingWrapper>
);

export default RocketModal;
